// services/medicineApiService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_QWIK_MEDIC_API_URL;
const TOKEN = process.env.REACT_APP_QWIK_MEDIC_TOKEN;
const GITHUB_FAST_URL =
  "https://raw.githubusercontent.com/ahasanhamza/QwikMedic-Medicine/main/medicineNewData.json";

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const medicineApiService = {
  // Get all medicines/products
  getAllMedicines: async () => {
    try {
      // Try medicineNewData endpoint first
      let response;


      // try {
      //   response = await axiosInstance.get('medicineNewData/');
      // } catch (error) {
      //   // Fallback to product endpoint
      //   response = await axiosInstance.get('product/');
      // }

      try {
        const fastRes = await fetch(GITHUB_FAST_URL);
        response = await fastRes.json();

        // if (Array.isArray(fastData) && fastData.length > 0) {
        //   console.log("Loaded medicines from GitHub");
        //   medicines = fastData;
        // }
      } catch (error) {
        console.log("GitHub fetch failed, trying API...");
      }


      return response.reverse(); // Show latest first
    } catch (error) {
      console.error('Error fetching medicines:', error);
      throw error;
    }
  },

  // Get single medicine
  getMedicine: async (id) => {
    // try {
    //   const response = await axiosInstance.get(`product/${id}`);
    //   return response.data;
    // } catch (error) {
    //   console.error('Error fetching medicine:', error);
    //   throw error;
    // }

    try {
      const fastRes = await fetch(GITHUB_FAST_URL);
      response = await fastRes.json();
      return response;
      // if (Array.isArray(fastData) && fastData.length > 0) {
      //   console.log("Loaded medicines from GitHub");
      //   medicines = fastData;
      // }
    } catch (error) {
      console.log("GitHub fetch failed, trying API...");
    }


  },

  // Search medicines
  searchMedicines: async (query = '', category = '', brand = '', availability = '') => {
    try {
      // Get all medicines
      let response;
      // try {
      //   response = await axiosInstance.get('medicineNewData/');
      // } catch (error) {
      //   response = await axiosInstance.get('product/');
      // }

      try {
        const fastRes = await fetch(GITHUB_FAST_URL);
        response = await fastRes.json();

        // if (Array.isArray(fastData) && fastData.length > 0) {
        //   console.log("Loaded medicines from GitHub");
        //   medicines = fastData;
        // }
      } catch (error) {
        console.log("GitHub fetch failed, trying API...");
      }


      let medicines = response;

      // Apply filters
      if (query) {
        const searchTerm = query.toLowerCase();
        medicines = medicines.filter(medicine => {
          const productName = medicine.productname || medicine.medicinename || '';
          const brandName = medicine.productbrand || medicine.companyname || '';
          const genericName = medicine.genericname || '';
          const categoryName = medicine.category || '';

          return (
            productName.toLowerCase().includes(searchTerm) ||
            brandName.toLowerCase().includes(searchTerm) ||
            genericName.toLowerCase().includes(searchTerm) ||
            categoryName.toLowerCase().includes(searchTerm)
          );
        });
      }

      if (category) {
        medicines = medicines.filter(medicine =>
          medicine.category === category
        );
      }

      if (brand) {
        medicines = medicines.filter(medicine =>
          (medicine.productbrand || medicine.companyname) === brand
        );
      }

      if (availability === 'available') {
        medicines = medicines.filter(medicine =>
          medicine.availablestatus === true
        );
      } else if (availability === 'unavailable') {
        medicines = medicines.filter(medicine =>
          medicine.availablestatus === false
        );
      }

      return medicines;
    } catch (error) {
      console.error('Error searching medicines:', error);
      throw error;
    }
  },

  // Update medicine
  // updateMedicine: async (id, medicineData) => {
  updateMedicine: async (updatedItem) => {
    // try {
    //   const response = await axiosInstance.patch(`product/${id}`, medicineData);
    //   return response.data;
    // } catch (error) {
    //   console.error('Error updating medicine:', error);
    //   throw error;
    // }

    try {
      const res = await fetch("https://qwik-medic-server.vercel.app/api/update-medicine", {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedItem), // { id, price }
      });

      if (!res.ok) {
        throw new Error("Failed to update medicine");
      }

      const data = await res.json();
      return data;

    } catch (error) {
      console.error("Update medicine failed:", error);
      throw error;
    }

  },

  // Delete medicine
  deleteMedicine: async (id) => {
    try {
      await axiosInstance.delete(`product/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting medicine:', error);
      throw error;
    }
  },

  // Get medicine discount from company contacts
  getMedicineDiscount: async () => {
    try {
      const response = await axiosInstance.get('companyContacts/1');
      return response.data;
    } catch (error) {
      console.error('Error fetching medicine discount:', error);
      throw error;
    }
  },
};